import type { TourStep } from '../tourTypes.js'
import Actions from '../../../Flux/index.js'
import { addMessage, applicationSlice, removeMessage } from '../../../Flux/Slice/Application/ApplicationSlice.js'
import { errorMessage } from '../../../Model/Message/IMessage.js'

export const uiTour: TourStep[] = [
  { content:
      <>
        <p>Welcome to spcfy!</p>
        <p>This tour will guide you through the spcfy UI.</p>
        <p>You can use the buttons below to stop the tour or go to the next step.</p>
        <p>Alternatively, you can use the space, enter or right arrow keys to advance.</p>
      </>, navigate: '/home'},
  { selector: "#tour-navigation", content: 'The navigation bar on top contains account management and global features' },
  { selector: "#tour-upload-button", content: 'This button opens the uploads sidebar, which can be used to manage file uploads' },
  { selector: "#tour-compact", content: 'Switch between a more compact view of spcfy, removing unavailable or additional information and a full-view mode' },
  { selector: "#tour-bell", content: 'Manage invitations and notifications' },
  { selector: "#tour-user", content: 'The currently logged in user and active licenses'},
  {
    selector: "#tour-user-menu",
    content: 'The dropdown allows you to logout or manage your user and organization profiles',
    preShow: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setHoverOverAvatar(true))
    },
    postShow: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setHoverOverAvatar(false))
    },
  },
  {
    selector: "#tour-sidebar",
    content: "The Sidebar allows you to navigate to different parts of spcfy",
    preShow:  async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(true))
    },
    stop: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    }
  },
  {
    selector: "#tour-sidebar-base",
    content: "Spcfy Base is available without any additional licenses and allows you to create and manage orders, as well as viewing public organizations offering their service via spcfy",
    stop: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    }
  },
  {
    selector: "#tour-sidebar-order-creation",
    content: "Orders can be created either in the role of a lab (i.e. having analyzed .fastq files) or as a customer (i.e. in need of finding a lab for providing .fastq files). Check our help center for more detailed information",
    stop: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    }
  },
  {
    selector: "#tour-sidebar-orders",
    content: "Previous orders can be found and searched for in this page.",
    stop: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    }
  },
  {
    selector: "#tour-sidebar-insight",
    content: "Spcfy Insight features require an active Insight license. Insight features allow you to organize analyzed data from several orders into projects. Projects can then be analyzed and visualized for insights into your short- or long term biodiversity goals.",
    stop: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    },
    postShow: async (context) => {
      context.dispatch(Actions[applicationSlice.name].setSidebarOpen(false))
    }
  },
  {
    selector: "#tour-errors",
    content: "Errors and notifications will popup here. Normal notifications will disappear after a short time, errors need to be dismissed manually",
    preShow: async (context) => {
      context.dispatch(addMessage(errorMessage("This is an example error", "tour-error")))
    },
    postShow: async (context) => {
      context.dispatch(removeMessage("tour-error"))
    }
  },
  {
    selector: "#tour-actions",
    content: "Internal actions and in particular network interactions will trigger a brief description on the bottom right, which will disappear after a while."
  },
  {
    content: "This concludes the basic spcfy UI tour. Check out our remaining tours!"
  }
];